/**
 * STAGGER-DELAY
 * Décalage d'apparition d'un élément dans une liste animée (barres, lignes).
 * Plafonné : sans plafond, le 40e élément d'un historique ou d'une liste de questions attendrait plusieurs secondes.
 */
export const STAGGER_MAX_SECONDS = 0.6

export function staggerDelay(index: number, step: number, offset = 0, max = STAGGER_MAX_SECONDS): number {
  return offset + Math.min(Math.max(index, 0) * step, max)
}
